<template>
  <!--财务信息-->
  <div>
    <div style="margin-bottom:20px;">
      <h3>财务信息</h3>
      <CardView
        :schema="noteInfo"
        :sourceData="resultData"
        :bordered="true"
        :column="2"
      ></CardView>
    </div>
    <div style="margin-bottom:20px;">
      <h3>财务明细</h3>
      <h5>（货币单位：万元）</h5>
      <TableView
        :columns="columns"
        :data="companyFinanceDetailList"
        :pagination="pageData"
        @handlePagination="handlePagination"
        :loading="loading"
        :bordered="bordered"
        :scroll="scroll"
        :rowKey="rowKey"
      ></TableView>
    </div>
  </div>
</template>
<script>
import { CardView, TableView } from '@/lxfintech-fe-components'
import { getEnterpriseFinanceSituation } from './api'
export default {
  components: { CardView, TableView },
  data() {
    return {
      noteInfo: {
        totalAssetsAssessment: {
          label: '资产总额评价',
        },
        totalLiabilitiesAssessment: {
          label: '负债总额评价',
        },
        totalRevenueAssessment: {
          label: '营业总收入评价',
        },
        netProfitAssessment: {
          label: '净利润评价',
        },
        totalAmountOfTaxPaymentAssessment: {
          label: '纳税总额评价',
        },
        assetLiabilityRatioAssessment: {
          label: '资产负债率评价',
        },
        netProfitMarginAssessment: {
          label: '净利润率评价',
        },
        netProfitRateOfAssetsAssessment: {
          label: '资产净利润率评价',
        },
        turnoverOfTotalAssetsAssessment: {
          label: '总资产周转率评价',
        },
        summary: {
          label: '分析结论',
        },
      },
      rowKey: 'id',
      scroll: { x: 1300 },
      columns: [
        {
          title: '序号',
          width: 100,
          dataIndex: 'order',
          key: 'order',
          fixed: 'left',
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
        },
        {
          title: '年份',
          dataIndex: 'year',
          key: 'year',
        },
        {
          title: '资产总额',
          dataIndex: 'totalAssets',
          key: 'totalAssets',
        },
        {
          title: '负债总额',
          dataIndex: 'totalLiabilities',
          key: 'totalLiabilities',
        },
        {
          title: '营业总收入',
          dataIndex: 'totalRevenue',
          key: 'totalRevenue',
        },
        {
          title: '净利润',
          dataIndex: 'netProfit',
          key: 'netProfit',
        },
        {
          title: '纳税总额',
          dataIndex: 'totalAmountOfTaxPayment',
          key: 'totalAmountOfTaxPayment',
        },
        {
          title: '资产负债率',
          dataIndex: 'assetLiabilityRatio',
          key: 'assetLiabilityRatio',
        },
        {
          title: '净利润率',
          dataIndex: 'netProfitMargin',
          key: 'netProfitMargin',
        },
        {
          title: '资产净利润率',
          dataIndex: 'netProfitRateOfAssets',
          key: 'netProfitRateOfAssets',
        },
        {
          title: '总资产周转率',
          dataIndex: 'turnoverOfTotalAssets',
          key: 'turnoverOfTotalAssets',
        },
      ],
      tableData: [],
      loading: false,
      bordered: true,
      pageData: {
        current: 1, //当前页
        pageSize: 10, //每页显示数量
        total: 0, //总共数量,
        showTotal: total => `总共 ${total} 条`, //展示总条数
      },
      resultData: {},
      companyFinanceDetailList: [],
    }
  },
  mounted() {
    const params = {
      enterpriseName: this.$store.getters['app/company'].name,
      // enterpriseName: '合肥胜利精密科技有限公司'
    }
    this._getEnterpriseFinanceSituation(params)
  },
  methods: {
    async _getEnterpriseFinanceSituation(params) {
      const { resultData } = await getEnterpriseFinanceSituation(params)
      this.resultData = resultData
      this.companyFinanceDetailList = resultData.companyFinanceDetailList
    },
  },
}
</script>
